export const FinanceRoutesRegex = '^/(finance|app/finance)/?([^/]+)?(?:/([^/]+))?(?:/([^/]+))?/?$';
export const FinanceRoutesRegexSpa = '^/finance/?([^/]+)?(?:/([^/]+))?(?:/([^/]+))?/?$';
export const SearchRoutesRegex = '^\\/search(?:\\/(?<new>new))?(?:\\/(?<uuid>.+))?$';
//# sourceMappingURL=routeRegexes.js.map